import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/single-app")({
  staticData: { pageTitle: "breadcrumbs.singleApp" },
  component: SingleAppLayout,
});

function SingleAppLayout() {
  return <Outlet />;
}
